import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import propTypes from "prop-types";
import ObjectHelper from "../../helpers/ObjectHelper";

import Loading from "../../Components/Loading";
import { Object } from "es6-shim";

const mapDispatchToProps = dispatch => ({});

class ReportDownloadList extends Component {
  static propTypes = {
    reports: propTypes.array,
    isFetching: propTypes.bool
  };

  state = {
    sort: ["sessionTS", true],
    isEditable: false,
    editedReports: [],
  };

  setSort = name => {
    const sort = this.state.sort || [];
    const { isEditable } = this.state;

    if (!isEditable) {
      if (sort[0] === name) {
        sort[1] = !sort[1];
      } else {
        sort[0] = name;
        sort[1] = true;
      }
      this.setState({ sort });
    }
  };

  getSortTitle(sortName, sortLabel) {
    const sort = this.state.sort || [];
    const { isEditable } = this.state;

    if (sort[0] !== sortName) {
      return <span>{sortLabel}</span>;
    }

    return (
      !isEditable ?
      <Fragment>
        <span className="active">
          {sortLabel}
          &nbsp;
        </span>
        <img
          src={
            sort[1]
              ? "/images/icon-arrow-down-blue.png"
              : "/images/icon-arrow-up.png"
          }
          alt=""
        />
      </Fragment>
      :
      <Fragment>
        <span className="active">
          {sortLabel}
          &nbsp;
        </span>
      </Fragment>
    );
  }

  getReports() {
    const { sort: [sortAttr, sortAsc] } = this.state;
    const { reports } = this.props;

    const sort = sortAsc
      ? (a, b) => {
        if (ObjectHelper.get(a, sortAttr) > ObjectHelper.get(b, sortAttr)) {
          return 1;
        }
        if (ObjectHelper.get(a, sortAttr) < ObjectHelper.get(b, sortAttr)) {
          return -1;
        }
        return 0;
      }
      : (a, b) => {
        if (ObjectHelper.get(b, sortAttr) > ObjectHelper.get(a, sortAttr)) {
          return 1;
        }
        if (ObjectHelper.get(b, sortAttr) < ObjectHelper.get(a, sortAttr)) {
          return -1;
        }
        return 0;
      };

    return Array.from((reports || [])).sort(sort);
  }

  getReportsGrouped() {
    const { reports } = this.props;

    const reportsGrouped = reports.reduce(({ groups, money: groupMoney, amount: groupAmount }, { filmId, filmName, amount, money }) => {
      if (!groups[filmId]) {
        groups[filmId] = { filmName, money, amount };
      } else {
        groups[filmId].money += money || 0
        groups[filmId].amount += amount || 0
      }
      return { groups, money: (groupMoney || 0) + money, amount: (groupAmount || 0) + amount };
    }, { groups: [] })

    return Object.assign(reportsGrouped || {}, { groups: Object.values((reportsGrouped || {}).groups || {}) });
  }

  enableFormEdit() {
    this.setState({ isEditable: true })
  }

  disableFormEdit() {
    const { editedReports } = this.state

    this.props.updateReports(editedReports)
    this.setState({ isEditable: false, editedReports: [] })
  }

  onChangeReportInput(value, attr, report) {
    const { editedReports } = this.state
    let reports = Object.assign([], editedReports);

    Object.assign(report, {[attr]:parseInt(value, 10)});

    if (reports.length) {
      let edited = false;
      reports.forEach((element, index) => {
        if (element.filmId === report.filmId && element.sessionTS === report.sessionTS && !edited) {
          Object.assign(element, { [attr]: parseInt(value, 10) });
          edited = true
        }
      })
      if (!edited) {
        reports.push(report)
      }
    } else {
      reports = [report];
    }

    this.setState({
      editedReports: reports
    })
  }

  render() {
    const { isEditable } = this.state;
    const { isFetching } = this.props;
    const [reports, reportsGrouped] = [this.getReports(), this.getReportsGrouped()];
    if (isFetching) {
      return <Loading loading />;
    }
    return (
      <div className="office-report__body">
        {(reports.length && (
          <table className="office__table">
            <thead>
              <tr>
                <td
                  className="large-column filter-column"
                  onClick={() => this.setSort("filmName")}
                >
                  {this.getSortTitle("filmName", "Фильм")}
                </td>
                <td
                  className="small-column filter-column"
                  onClick={() => this.setSort("sessionTS")}
                >
                  {this.getSortTitle("sessionTS", "Сеанс")}
                </td>
                <td
                  className="small-column filter-column"
                  onClick={() => this.setSort("amount")}
                >
                  {this.getSortTitle("amount", "Билетов")}
                </td>
                <td
                  className="small-column filter-column"
                  onClick={() => this.setSort("money")}
                >
                  {this.getSortTitle("money", "Выручка")}
                </td>
                {(!isEditable && (
                  <td
                    className="small-column action-column"
                    onClick={() => this.enableFormEdit()}
                  >
                    <span>Редактировать</span>{" "}
                    <img src="/images/" alt="" className="icon" />
                  </td>
                )) || (
                    <td
                      className="small-column action-column"
                      onClick={() => this.disableFormEdit()}
                    >
                      <span>Сохранить</span>{" "}
                      <img
                        src="/images/icon-save.png"
                        alt=""
                        className="icon"
                      />
                    </td>
                  )}
              </tr>
            </thead>
            <tbody>
              {reports.length &&
                reports.map((element, index) => (
                  <tr key={index}>
                  <td className="large-column report-film-name"><span style={{ width: "350px", maxWidth: "350px", display: "inline-block" }}>
                      {element.type === 'auto' &&
                        <span className="fa fa-database report-type-icon"></span>
                      }
                      {element.filmName}</span></td>
                    <td className="small-column gray">
                      {element.sessionTime}
                    </td>
                    <td className="small-column">
                      {isEditable ?
                        <input type='number' className="office-report__invisible-input" defaultValue={element.amount || 0} onBlur={e => this.onChangeReportInput(e.target.value, 'amount', Object.assign({}, element))} /> :
                        <span>{element.amount}</span>
                      }
                    </td>
                    <td className="small-column">
                      {isEditable ?
                        <input type='number' step="100" className="office-report__invisible-input" defaultValue={element.money || 0} onBlur={e => this.onChangeReportInput(e.target.value, 'money', Object.assign({}, element))} /> :
                        <span>{element.money}</span>
                      }</td>
                    <td className="small-column" />
                  </tr>
                ))}
            </tbody>
            {(reportsGrouped) && (
              <tfoot>
                <tr>
                  <td className="large-column">Итого:</td>
                  <td className="small-column" />
                  <td className="small-column">
                    {reportsGrouped.amount}
                  </td>
                  <td className="small-column">
                    {reportsGrouped.money}
                  </td>
                  <td className="small-column" />
                </tr>
                {reportsGrouped.groups.map((element, index) => (
                  <tr key={"tr-key-" + index}>
                    <td className="large-column">{element.filmName}</td>
                    <td className="small-column" />
                    <td className="small-column">{element.amount || 0}</td>
                    <td className="small-column">{element.money || 0}</td>
                    <td className="small-column" />
                  </tr>
                )) || null}
              </tfoot>
            )}
          </table>
        )) || null}
      </div>
    );
  }
}
export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(ReportDownloadList)
);



// WEBPACK FOOTER //
// ./src/containers/download/_list.jsx